export default "__VITE_ASSET__DgoRFJCo__"